import { Controller } from "@hotwired/stimulus"
import { pdpCommonProps } from "@/lib/pdpAnalytics"

const SURVEY_NAME = "Room photo follow-up"

export default class extends Controller {
  static targets = ["picker", "thanks"]

  static values = { userId: String, uid: String }

  connect() {
    this.capture("room_photo_button_shown")
  }

  open() {
    this.capture("room_photo_modal_opened")
    this.dispatch("show-alert-modal", { prefix: false, detail: "room_photos_modal" })
  }

  pick(event) {
    const file = event.target.files[0]
    if (!file) return

    this.capture("room_photo_selected", { file_type: file.type, file_size: file.size })
    this.pickerTarget.classList.add("hidden")
    this.thanksTarget.classList.remove("hidden")
    this.renderSurvey()
  }

  renderSurvey() {
    window.posthog?.getActiveMatchingSurveys?.((surveys) => {
      const survey = surveys.find((candidate) => candidate.name === SURVEY_NAME)
      if (survey) window.posthog.renderSurvey(survey.id, "#room-photo-survey")
    }, true)
  }

  capture(event, properties = {}) {
    const galleryData = document.getElementById("product-gallery")?.dataset || {}
    window.posthog?.capture(event, {
      ...pdpCommonProps(galleryData),
      user_id: this.userIdValue ? parseInt(this.userIdValue, 10) : null,
      uid: this.uidValue,
      ...properties,
    })
  }
}
